import React, { useEffect, useState } from "react";
import { createPatientApi } from "../../../../api-helpers/PatientApiHelper";
import { IdNamePair, InternalCareTeamMembers } from "patients-experience-client";
import OffCanvas from "../../../../components/offCanvas";
import { EditWellinksCareTeam } from "./EditWellinksCareTeam";
import Toaster, { ToastConfig } from "../../../../components/Toaster";
import { ErrorTypes } from "../../../../interfaces/errors";
import Spinner from "../../../../components/Spinner";
import { ReactComponent as EditIcon } from "../../../../assets/img/EditPatientInfo.svg";

interface CareTeamProps {
    patientId: string | undefined;
}

export const WellinksCareTeam: React.FC<CareTeamProps> = (props: CareTeamProps) => {
    const patientApi = createPatientApi();
    const [offCanvasTitle, setOffCanvasTitle] = useState("");
    const [offCanvasShow, setOffCanvasShow] = useState(false);
    const [internalCareTeam, setInternalCareTeam] = useState<InternalCareTeamMembers>({} as InternalCareTeamMembers);
    const [loading, setLoading] = useState<boolean>(true);
    const [showToast, setShowToast] = useState(false);
    const [toastConfig, setToastConfig] = useState<ToastConfig>({
        type: "success" as ErrorTypes,
        title: "",
        icon: "",
    });

    const getCareTeam = async () => {
        setLoading(true);
        try {
            const response = await patientApi.patientsControllerGetInternalCareTeam(props.patientId!);
            setInternalCareTeam(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const onSubmit = async (toasterConfig: ToastConfig) => {
        setToastConfig(toasterConfig);
        setShowToast(true);
        getCareTeam();
    };

    useEffect(() => {
        if (props.patientId) {
            getCareTeam();
        }
    }, [props.patientId])


    const handleOffCanvasShow = () => {
        setOffCanvasTitle("Edit Wellinks Care Team");
        setOffCanvasShow(!offCanvasShow);
    };

    return (
        <>
        {loading && <Spinner />}
        <div className="row">
            <Toaster
                show={showToast}
                onClose={() => setShowToast(false)}
                type={toastConfig.type}
                title={toastConfig.title}
                message={toastConfig.message}
                icon={toastConfig.icon}
            />
        </div>
            <div className='d-flex align-items-center'>
                <h2 className='h4 m-0'>Wellinks Care Team</h2>
                <a href='javascript:void(0)' className={`btn d-flex align-items-center py-1 pe-4 ms-auto`} onClick={() => handleOffCanvasShow()}>
                    <EditIcon />
                    <span className="d-inline-block lh-sm ms-2 border-primary border-bottom text-secondary">Edit</span>
                </a>
            </div>
            <hr />
            <div className="row g-2">
                <div className="col-12 col-md-4 col-lg-4">
                    <div className="mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Primary Provider
                        </label>
                        <p className="fw-medium mb-0 fs-14">{internalCareTeam?.primaryProvider?.name ? internalCareTeam?.primaryProvider?.name : '-'}</p>
                    </div>
                </div>
                <div className="col-12 col-md-4 col-lg-4">
                    <div className="mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Primary Clinical Liaison
                        </label>
                        <p className="fw-medium mb-0 fs-14">{internalCareTeam?.primaryCoach?.name ? internalCareTeam?.primaryCoach?.name : '-'}</p>
                    </div>
                </div>
                <div className="col-12 col-md-4 col-lg-4">
                    <div className="mb-2">
                        <label
                            className="form-label text-light mb-1 fs-14"
                        >
                            Other Care Team Members
                        </label>
                        <p className="fw-medium mb-0 fs-14">
                            {internalCareTeam.otherMembers?.length ? internalCareTeam?.otherMembers.map((other: IdNamePair) => other.name).join(', ') : '-'}
                        </p>
                    </div>
                </div>
            </div>

            <OffCanvas
                title={offCanvasTitle}
                offCanvasShow={offCanvasShow}
                setOffCanvasShow={setOffCanvasShow}
            >
                <EditWellinksCareTeam patientId={props.patientId} selectedTeam={internalCareTeam} onSubmit={onSubmit} setOffCanvasShow={setOffCanvasShow} />
            </OffCanvas>
        </>
    );
}